import React from 'react';
import PropTypes from 'prop-types';
import { adSettings } from '../../../content/main.json';
import BodyElement from './BodyElement';
import styles from './ArticleBody.module.styl';
import AdPosition from './AdPosition';
import Sponsor from '../Sponsor';

const ArticleBody = ({ contentElements, showSponsorship }) => {
  let runningWordCount = 0;

  const adsToInsert = [...adSettings.positions];

  const insertSponsorAfterParagraph = contentElements.length > 3 ? 2 : 0;
  let runningParagraphCount = 0;

  return (
    <div className={styles.story}>
      {contentElements.map((contentElement) => {
        let insertAd = false;
        let insertSponsor = false;
        if (contentElement.type === 'text') {
          runningWordCount += contentElement.content.split(/\s/).length;
          if (adsToInsert.length && runningWordCount >= adsToInsert[0].wordCount) {
            // Remove the first element of the array.
            insertAd = adsToInsert.shift();
          }
          if (showSponsorship && runningParagraphCount === insertSponsorAfterParagraph) {
            insertSponsor = true;
          }
          runningParagraphCount += 1;
        }
        return (
          <React.Fragment>
            {insertSponsor && (
              <Sponsor layout="stacked" className={styles.sponsorWrapper} />
            )}
            {/* eslint-disable-next-line no-underscore-dangle,react/jsx-props-no-spreading */}
            <BodyElement {...contentElement} key={contentElement._id} />
            {insertAd && (
              <AdPosition positionId={insertAd.id} overline={insertAd.overline} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

ArticleBody.propTypes = {
  contentElements: PropTypes.arrayOf(PropTypes.object).isRequired,
  showSponsorship: PropTypes.bool,
};

ArticleBody.defaultProps = {
  showSponsorship: false,
};

export default ArticleBody;
